export enum LogoTheme {
  Classic = 'classic',
  White = 'white',
  OnlySymbol = 'onlySymbol'
}
